import { Bloom, EffectComposer } from "@react-three/postprocessing";
import { useContext } from "react";
import stateContext from "../Context/StateContext";

export const Effects = () => {
    const globalState = useContext(stateContext);
    return (
        <EffectComposer multisampling={4}>
            <Bloom
                luminanceThreshold={0.005}
                intensity={0.2}
                levels={1}
                exposure={0.4}  
                strength={0.1}
                ref={globalState.bloomRef}
            />
        </EffectComposer>
    );
};
